<template>
    <div>
        <v-card color="light">
            <v-card-title>
                Company Mapping <v-spacer></v-spacer>
                <div :style="{
                    width: '200px',
                    position: 'absolute',
                    right: '20px',
                    top: '5px',
                    textAlign: 'right'
                }">
                    <v-tooltip
                        bottom
                        :max-width="300">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                icon
                                v-on="on"
                                type="button"
                                class="mt-3"
                                :disabled="isRefreshing"
                                @click="onRefresh"
                            >
                                <v-progress-circular
                                    v-if="isRefreshing"
                                    indeterminate
                                   >
                                </v-progress-circular>
                                <v-icon v-else>mdi-refresh-circle</v-icon>
                            </v-btn>
                        </template>
                        <span>This button will refresh company and location.</span>
                    </v-tooltip>
                </div>
            </v-card-title>
            <CompanyLocation v-if="!isRefreshing" :id="id" :metas="metas" :warehouseLocations="warehouseLocations" ref="fc"/>

            <v-card-title>
                From Company Location Mapping <v-spacer></v-spacer>
            </v-card-title>
            <CompanyLocation v-if="!isRefreshing" :id="id" :metas="metas" :warehouseLocations="warehouseLocations" machship_field="fromCompanyLocationId" ref="fcl" />
        </v-card>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import CompanyLocation from './CompanyLocation'
export default {
    props: {
        id: { type: Number, default: null },
        metas: { type: Array, default: [] },
    },
    components: {
        CompanyLocation
    },

    data() {
        return {
            isRefreshing: true,
            warehouseLocations: [],
        }
    },

    computed: {
        integrationId() {
            return this.id ?? parseInt(window.location.pathname.split('/')[2])
        },
    },

    mounted() {
        this.fetchWarehouseLocations()
    },

    methods: {
        // on refresh carrier and services
        async onRefresh() {
            try {
                this.isRefreshing = true
                await this.$http.post('/api/machship/refresh', { integration_id : this.integrationId })
                this.$refs.fc.onRefreshedClicked()
                this.$refs.fcl.onRefreshedClicked()
                EventBus.$emit('show-success', "Successfully refresh company and location")
            } catch (err) {
                EventBus.$emit('show-error', err)
            }


            this.isRefreshing = false
        },

        async fetchWarehouseLocations() {
            try {

                let res = await this.$http.get(`/api/valuelookups/warehouse-locations/` + this.integrationId)

                if (!res || !res.status ) {
                    console.log("[WAREHOUSE_LOCATION] unable to get warehouse locations", res)
                    return;
                }

                this.warehouseLocations = res.data.result

            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch warehouse locations of " + this.company.name)
                console.log("[WAREHOUSE_LOCATION] error", error);
            }

            this.isRefreshing = false
        },
    }
}
</script>